'use strict';

var base = require('./base');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,
    selectCheckbox: base.selectCheckbox,

    showRatings: function () {
        $('body').on('click', '.bv-review-highlights-toggle', function () {
            var reviewsContainer = $('#bv-reviews-container');
            reviewsContainer.toggleClass('hide');
            if (reviewsContainer.hasClass('hide')) {
                $(this).find('.display').text('Show More');
            } else {
                $(this).find('.display').text('Hide');
            }
        });

        $('body').on('click', '.bv_ratings_summary', function () {
            var reviewsContainer = $('#bv-reviews-container');
            reviewsContainer.removeClass('hide');
            $('.bv-review-highlights-toggle').find('.display').text('Hide');
        });

        // update reviews display
        setTimeout(function () {
            var numReviews = $('.bv_numReviews_component_container');
            var reviewHighlights = $('.bv-review-highlights');
            if (numReviews) {
                numReviews = numReviews.find('[itemprop="reviewCount"]').attr('content');
            }

            // Has reviews, no summary
            if (numReviews >= 1 && reviewHighlights.children().length === 0) {
                // Hide summary "Show More Reviews" link
                // Show total reviews
                $('#bv-reviews-container').removeClass('hide');
                $('#bv-review-highlights-toggle-container').remove();
            }

            // No reviews
            if (!numReviews) {
                $('.bv-review-highlights').remove();
                $('#bv-reviews-container').remove();
                $('#bv-review-highlights-toggle-container').remove();
                $('.recommendations').last().remove();
            }
        }, 2500);
    },

    pdpCarousel: function () {
        $('.js-desktop-carousel').slick({
            arrows: true,
            infinite: false,
            prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
            nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
            lazyLoad: 'ondemand',
            asNavFor: '.js-desktop-carousel-nav'
        });
        $('.js-desktop-carousel-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            vertical: true,
            prevArrow: '<span class="slick-arrow-up fi fi--carrot-left"></span>',
            nextArrow: '<span class="slick-arrow-down fi fi--carrot-right"></span>',
            asNavFor: '.js-desktop-carousel'
        });

        $('body').on('click', '.js-pdp-carousel-item', function () {
            var slide = parseInt($(this).attr('data-index'), 10);
            $('.js-desktop-carousel').slick('slickGoTo', slide);
        });
    },

    productAccordion: function () {
        $('body').on('click', '.accordion-header', function () {
            $(this).toggleClass('open');
            $(this).next('.accordion-content').first().toggleClass('show');
        });
    },

    fabricAttribute: function () {
        $('body').on('click', '.fabric-button', function () {
            var fabricButton = $(this);
            var fabricId = fabricButton.attr('data-material-id');
            var displayName = fabricButton.text();
            var showStyleMessage = $('#showStyleMessage');
            var fabricDisplayed = $('#fabricDisplayed');

            // fabric details display
            showStyleMessage.addClass('show');
            fabricDisplayed.text(displayName);
            $('.fabricDetail').removeClass('show');
            var fabricDetail = $('#fabricContainer-' + fabricId);
            fabricDetail.addClass('show');

            // selected fabric button active state
            if (fabricButton.hasClass('selected')) {
                fabricButton.removeClass('selected');
                showStyleMessage.removeClass('show');
                fabricDetail.removeClass('show');
                $('.js-color-value-option').each(function () {
                    var color = $(this);
                    color.fadeTo(150, 1);
                });
            } else {
                $('.fabric-button').removeClass('selected');
                fabricButton.addClass('selected');
                $('.js-color-value-option').each(function () {
                    var color = $(this);
                    var colorMaterial = color.attr('data-material');
                    if (colorMaterial !== fabricId) {
                        color.fadeTo(150, 0.10);
                    } else {
                        color.fadeTo(150, 1);
                    }
                });
            }
        });
    },

    closeFabricDetails: function () {
        $('body').on('click', '.fabricDetailsClose', function () {
            $('.js-color-value-option').each(function () {
                var color = $(this);
                color.fadeTo(150, 1);
            });
            $('.fabric-button').removeClass('selected');
            $('#showStyleMessage').removeClass('show');
            $('.fabricDetail').removeClass('show');
        });
    },

    compareFabrics: function () {
        $('body').on('click', '#compareFabricsButton', function () {
            $('#compareFabricsModal').modal('show');
        });
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            const productType = $('.js-product').data('product-type');
            if (productType !== 'productSet') {
                var productURL = data.productUrl;
                // update URL
                window.history.replaceState(null, null, productURL);
                $('#nav-description').empty().html(data.longDescription);
                $('#nav-features').empty().html(data.shortDescription);
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    startContentAPlusVideo: function () {
        $('body').on('click', '.js-start-youtube-video', function () {
            const $blockWrapper = $(this).find('.js-start-youtube-video-wrapper');

            if ($blockWrapper.is(':visible')) {
                const videoWidth = Math.ceil($blockWrapper.width());
                const videoHeight = Math.ceil($blockWrapper.height());
                const videoId = $(this).data('youtube-id');

                $blockWrapper.hide();
                $(this).find('.js-start-youtube-video-place').html('<iframe width="' + videoWidth + '" height="' + videoHeight + '" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen></iframe>');
            }
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.attr('data-pid', response.data.product.id);
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                $('body').trigger('wishlist:updateCount');
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });

            const productType = $('.js-product').data('product-type');
            if (productType !== 'productSet') {
                module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
            } else {
                module.exports.methods.updateAddToCartEnableDisableOtherElements(!response.product.readyToOrder);
            }
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            const $checkTypeDiv = $('.js-availability-type-check');

            if ($checkTypeDiv.length) {
                if (response.product.availability.type === 'InStock') {
                    $checkTypeDiv.hide();
                } else {
                    $checkTypeDiv.show();
                }
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.js-size-chart').on('click', '.js-size-chart-link', function (e) {
            e.preventDefault();

            var url = $(this).attr('href');
            var $prodSizeChart = $('.js-size-chart-content');

            // Using !$(this).hasClass('js-click-once') we prevent ajax loading due to multiple button clicks
            if (!$(this).hasClass('js-click-once') && $prodSizeChart.is(':empty')) {
                $(this).addClass('js-click-once');

                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);

                        $('#sizeChartModal').modal('show');
                        $('.js-size-chart-link').removeClass('js-click-once');
                    }
                });
            } else {
                $('#sizeChartModal').modal('show');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            // eslint-disable-next-line no-restricted-globals
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    initVideo: base.initVideo,
    openVideo: base.openVideo,
    openImage: base.openImage,
    displaySelectedColorValue: base.displaySelectedColorValue,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal
};
